<template>
    <!-- 批量授权人员流程模板对应流程实例的数据权限 -->
    <div class="data-auth-process-batch-content">
        <!-- 人员数据容器 -->
        <div class="user-box">
            <div class="tree-type">
                <div class="type-item" @click="changeTreeType(1)" :class="{ active: treeType == 1 }">
                    单个
                </div>
                <div class="type-item"  @click="changeTreeType(2)" :class="{ active: treeType == 2 }">
                    批量
                </div>
            </div>
             <OrgUserTree @loadUserForms="loadUserForms" ref="orgUserTree" :showCheckbox="showCheckbox"></OrgUserTree>
        </div>
        <!-- 流程方案数据容器 -->
        <!-- <div class="form-box">
            <div class="table-search">
                <div class="choose-people" v-if="showCheckbox==false">当前人&nbsp;:&nbsp;<span class="choose-people-name">{{choosePeopleName}}</span></div>
                <el-select style="width: 140px;" clearable v-model="searchParams.processDefinitionId"  @change="handleSearch" placeholder="请选择流程定义">
                    <el-option
                    v-for="item in processDefineSearchList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-input maxlength="100" style="margin-left:20px; width: 180px;" v-model.trim="searchParams.serviceName" placeholder="请输入流程方案">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>
            <div class="table-body">
                  <el-table :data="processLists" style="width: 100%;" :border="true" v-loading="loading" :height="'51vh'"  @selection-change="handleSelectionProcess">
                      <el-table-column
                        type="selection"
                        width="40">
                      </el-table-column>
                      <el-table-column prop="serviceName" label="流程方案名称" :show-overflow-tooltip="true" width="120"></el-table-column>
                      <el-table-column prop="definitionName" label="所属流程定义" :show-overflow-tooltip="true" width="100"></el-table-column>
                      <el-table-column prop="businessName" label="业务分类" :show-overflow-tooltip="true" width="100" ></el-table-column>
                      <el-table-column prop="trueName" label="创建人" width="70"></el-table-column>
                      <el-table-column prop="created" label="创建时间" :sortable="true" width="150"></el-table-column>
                  </el-table>
            </div>
            <div class="table-page">
                <el-pagination
                  background
                  layout="total,sizes,prev, pager, next"
                  :page-size="page.pageSize"
                  :page-sizes="[5, 10, 20, 30, 50]"
                   @current-change="handleCurrentChange"
                   @size-change="queryFormDataByPageSize"
                  :current-page.sync="page.currentPage"
                  :total="page.totalPageNum">
                </el-pagination>
            </div>

        </div> -->
        <!-- 部门数据容器 -->
        <div class="org-box">
 <!--           <div class="org-search">

            </div> -->
            <div class="choose-people" v-if="showCheckbox==false">当前人&nbsp;:&nbsp;<span class="choose-people-name">{{choosePeopleName}}</span></div>
            <div class="org-body">
                <template>
                  <el-table
                    ref="multipleOrgTable" 
                    :data="orgTableData"
                    @selection-change="handleSelectionOrg"
                    height="60vh"
                    border>
                    <el-table-column
                      type="selection"
                      align="center"
                      width="50">
                    </el-table-column>

                    <el-table-column
                      prop="label"
                      :show-overflow-tooltip="true"
                      label="部门名称"
                       width="260"
                     >
                    </el-table-column>
                    <el-table-column
                      label="详细权限"
                      width="120">

                       <template slot-scope="scope">
                          <el-select disabled v-model="scope.row.operAuthIds" placeholder="请选择">
                                  <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                            </el-select>
                        </template>

                    </el-table-column>
                  </el-table>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import OrgUserTree from '@/components/OrgUserTree/OrgUserTree';
    import {getUserProcessServiceDataAuthList, getOrgAuthList} from '@/data-model';
    export default{
        components: {
            OrgUserTree
        },
        data () {
            return {
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 0 // 总页数
                },
                processLists: [],
                modelsData: [],
                tableData: [],
                searchModelName: '',
                searchFunctionName: '',
                searchAppName: '',
                userId: '',
                choosePeopleName: '所有',
                orgTableData: [],
                options: [{
                    value: '2',
                    label: '修改'
                }, {
                    value: '3',
                    label: '删除'
                }, {
                    value: '2,3',
                    label: '查看'
                }],
                processServices: [],
                orgs: [],
                treeType: 1,
                showCheckbox: false,
                searchParams: {
                    processDefinitionId: '',
                    serviceName: '',
                    producer: '',
                    serviceType: '',
                    state: null,
                    unNeedAuth: 'true'
                }
            };
        },
        props: {
            processDefineSearchList: {
                type: Array
            }
        },
        created () {
            this.searchParams.serviceType = '';
            this._getFormData();
            this.initOrgList();
        },
        methods: {
            loadUserForms (obj) {
                if (this.treeType === 1) { // 单个
                    this.userId = obj.id;
                    this.choosePeopleName = obj.label;
                    this.setDefaultChoose();
                } else { // 批量
                    let userids = [];
                    for (var i = 0; i < obj.length; i++) {
                        userids.push(obj[i].id);
                    }
                    this.userId = userids.join(',');
                    this.$refs.multipleOrgTable.clearSelection();
                    // this._getFormData();
                }
            },
            async setDefaultChoose () {
                let checkedrow = [];
                let selectedArr = [];
                this.$refs.multipleOrgTable.clearSelection();
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let userAuth = await getUserProcessServiceDataAuthList({userId: this.userId});
                if (userAuth && userAuth.length > 0) {
                    selectedArr = userAuth;
                    this.orgTableData.forEach(item => {
                        selectedArr.forEach(i => {
                            if (i.orgId === item.id) {
                                checkedrow.push(item);
                            }
                        });
                    });
                    this.$nextTick(() => {
                        checkedrow.forEach(row => {
                            this.$refs.multipleOrgTable.toggleRowSelection(row, true);
                        });
                    });
                }
                loading.close();
            },
            async _getFormData () {
                // this.loading = true;
                // let formData = await getProcessServiceList(Object.assign({}, {
                //     currentPage: this.page.currentPage,
                //     pageSize: this.page.pageSize
                // }, this.searchParams));
                // if (formData && formData) {
                //     this.processLists = formData.data;
                //     this.processServiceIds = formData.otherData ? formData.otherData.prosessServiceIds : '';
                //     this.page = {
                //         currentPage: formData.currentPage,
                //         pageSize: this.page.pageSize,
                //         totalPageNum: formData.totalPageNum
                //     };
                // }
                // this.loading = false;
            },
            handleCurrentChange (val) {
                this.page.currentPage = val;
                this._getFormData();
            },
            async initOrgList () {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let param = {};
                let data = await getOrgAuthList(param);
                this.orgTableData = data;
                loading.close();
            },
            handleSelectionOrg (rows) {
                this.orgs = rows;
            },
            handleSelectionProcess (rows) {
                this.processServices = rows;
            },
            buildParam () {
                let param = {};
                param.processServiceId = JSON.stringify(this.processServices);
                param.selectedOrgIds = JSON.stringify(this.orgs);
                param.users = this.userId;
                return param;
            },
            searchModel () {
                this._getFormData();
            },
            changeTreeType (o) {
                this.treeType = o;
                this.userId = '';
                this.$refs.multipleOrgTable.clearSelection();
                if (o === 1) {
                    this.showCheckbox = false;
                } else if (o === 2) {
                    this.showCheckbox = true;
                }
                this._getFormData();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this._getFormData();
            },
            handleSearch () {
                this.handleCurrentChange(1);
            }
        }

    };
</script>

<style lang="less" scoped="scoped">
    .data-auth-process-batch-content{
        width: 100%;
        height: 65vh;
        display: flex;
        overflow: auto;
        .user-box{
           flex: 1;
           min-width: 180px;
           .tree-type{
               display: flex;
               .type-item{
                  flex: 1;
                  cursor: pointer;
                  text-align: center;
                  height: 30px;
                  line-height: 30px;
                  background: #fff;
                  border: 1px solid #dcdfe6;

               }
               .active{
                   color: #fff;
                   background-color: #409eff;
                   border-color: #409eff;
               }
           }
           /deep/ .search-content{
               .el-input__inner{
                   border-radius: 0px;
                   border-top: none;
               }
           }
           // .tree-type:first-child{
           //   border-left: 1px solid #dcdfe6;
           //   border-radius: 4px 0 0 4px;

           // }
        }
        .form-box{
            flex: 4;
            padding-left: 10px;
            width: 38vw;
            overflow: auto;
            .table-search{
                display:flex;
                .item{
                    width: 160px;
                    margin-right: 10px;
                }
                
             }
            .table-body{
                margin-top: 4px;
                width: 100%;
                // .el-table th.gutter{
                // 		display: table-cell!important;
                // 	}

                // .has-gutter {
                //     .gutter {
                //         width: 0px !important;
                //         display: block;
                //     }
                // }
            }
            .table-page{
                margin-top: 10px;
            }
        }
        .org-box{
           flex: 2;
           // height:520px;
           overflow: auto;
           padding-left: 10px;
           min-width: 230px;
        }
        .choose-people{
              margin-right: 10px;
              width: 120px;
              height: 32px;
              line-height: 32px;
              .choose-people-name{
                  width: 60px;
                  font-size: 18px;
                  color: red;
                  text-overflow:ellipsis;
              }

          }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataAuthProcessBatch/DataAuthProcessBatch.vue